<template>
  <div class="row">
    <div class="col-md-12 d-flex justify-content-between">
      <h1 class="h3 mb-3 text-gray-800">
        {{ $t("Relatórios de Atividades") }}
      </h1>

      <b-dropdown
        no-caret
        variant="primary"
        size="sm"
        v-b-tooltip.hover
        right
        title="Menu de Relatórios de Atividades"
      >
        <template #button-content>
          Menu
          <i class="fas fa-bars"></i>
        </template>
        <b-dropdown-group id="dropdown-group-1" header="Relatórios de Atividades">
          <b-dropdown-item
            :to="'/dashboard/relatorios/atividades/home'"
            :disabled="$route.name == 'relatorios_home_atividades'"
          >
            Todas Atividades
          </b-dropdown-item>
          <b-dropdown-item
            :to="'/dashboard/relatorios/atividades/inscritos'"
            :disabled="$route.name == 'relatorios_home_atividades_inscritos'"
          >
            Atividades do SCFV
          </b-dropdown-item>
          <b-dropdown-item
            :to="'/dashboard/relatorios/atividades/graficos'"
            :disabled="$route.name == 'graficos_atividades'"
          >
            Gráficos de Atividades
          </b-dropdown-item>
        </b-dropdown-group>
      </b-dropdown>
    </div>
    <div class="col-md-12">
      <load v-if="loading" />
      <router-view v-else />
    </div>
  </div>
</template>
<script>
export default {
  name: "ReportsAtividades",
  metaInfo() {
    return {
      title: this.$i18n.t("Relatórios de Atividades"),
    };
  },
  mounted() {},
  data() {
    return {
      loading: false,
    };
  },
  methods: {},
};
</script>
